import {v4 as uuidv4} from 'uuid';

export function transformData(inputJson) {
  return inputJson.map(item => ({
    id: item?.uuid ?? uuidv4(),
    rowIconOne: 'sprite icEditHollow',
    rowIconTwo: 'sprite icBin',
    rowPersuasion: item?.showPersuasion
      ? {
          rowPersTxt: 'GST details were saved successfully',
          rowPersColor: '#1a7971',
          rowPersIc: 'sprite icGreenBgTick',
          rowPersBackground:
            'linear-gradient(90.13deg, #C1F1DD 0.02%, rgba(193, 241, 221, 0) 112.91%)',
        }
      : {},
    rowEditData: {
      gstOwner: item?.gstOwner
        ? item?.gstOwner?.charAt(0)?.toUpperCase() + item?.gstOwner.slice(1)
        : 'N/A',
      gstNumber: item?.gstNumber ?? 'N/A',
      billingAddress: item?.billingAddress ?? 'N/A',
      companyName: item?.companyName ?? 'N/A',
      state: item?.state ?? 'N/A',
      pinCode: item?.pinCode ?? 'N/A',
      travellerGstId: item?.travellerGstId ?? null,
      isDefault: item?.isDefault ?? false,
    },
    rowDeleteData: {
      gstOwner: item?.gstOwner ?? 'N/A',
      companyName: item?.companyName ?? 'N/A',
      gstNumber: item?.gstNumber ?? 'N/A',
      billingAddress: item?.billingAddress ?? 'N/A',
      travellerGstId: item?.travellerGstId ?? null,
    },
    tableRowData: [
      {
        id: uuidv4(),
        rowDataTxt: item?.gstOwner
          ? item?.gstOwner?.charAt(0)?.toUpperCase() + item?.gstOwner.slice(1)
          : 'N/A',
        rowDataColor: '#4a4a4a',
        rowDataWeight: 700,
        dataTxtWidth: '80px',
      },
      {
        id: uuidv4(),
        rowDataTxt: item?.gstNumber ?? 'N/A',
        rowDataColor: '#4a4a4a',
        rowDataWeight: 400,
        dataTxtWidth: '144px',
      },
      {
        id: uuidv4(),
        rowDataTxt: item?.companyName ?? 'N/A',
        rowDataColor: '#4a4a4a',
        rowDataWeight: 400,
        dataTxtWidth: '170px',
        dataTagTxt: item?.isDefault ? 'Default' : '',
        dataTagColor: item?.isDefault ? '#FFF' : 'black',
        dataTagBg: item?.isDefault
          ? 'linear-gradient(102.78deg, #554276 10.64%, #292B48 146.51%)'
          : '',
      },
      {
        id: uuidv4(),
        rowDataTxt: item?.state ?? 'N/A',
        rowDataColor: '#4a4a4a',
        rowDataWeight: 400,
        dataTxtWidth: '112px',
      },
      {
        id: uuidv4(),
        rowDataTxt: item?.billingAddress ?? 'N/A',
        rowDataColor: '#4a4a4a',
        rowDataWeight: 400,
        dataTxtWidth: '170px',
      },
      {
        id: uuidv4(),
        rowDataTxt: '',
        rowDataColor: '',
        rowIconOne: 'sprite icEditHollow',
        rowIconTwo: '',
      },
      {
        id: uuidv4(),
        rowDataTxt: '',
        rowDataColor: '',
        rowIconOne: '',
        rowIconTwo: 'sprite icBin',
      },
    ],
  }));
}

export function convertGstDataMobile(inputJson) {
  return inputJson.map(item => ({
    id: item?.uuid ?? uuidv4(),
    gstDtlCardBg: '#f7f4f4',
    gstDtlHeading: item?.companyName ?? 'N/A',
    gstOwner: item?.isDefault
      ? 'DEFAULT'
      : item?.gstOwner
      ? item?.gstOwner?.charAt(0)?.toUpperCase() + item?.gstOwner.slice(1)
      : 'N/A',
    gstDtlCardTag: {
      cardTagTxt: item?.isDefault ? 'Default' : '',
      cardTagColor: item?.isDefault
        ? '#FFF'
        : item?.gstOwner.toLowerCase() === 'client'
        ? '#008cff'
        : item?.gstOwner.toLowerCase() === 'self'
        ? '#FFF'
        : 'black',
      cardTagBgColor: item?.isDefault
        ? 'linear-gradient(102.78deg, #554276 10.64%, #292B48 146.51%)'
        : item?.gstOwner.toLowerCase() === 'client'
        ? ''
        : item?.gstOwner.toLowerCase() === 'self'
        ? '#008cff'
        : '',
      cardTagBorderColor:
        item?.gstOwner.toLowerCase() === 'client'
          ? '#008cff'
          : item?.gstOwner.toLowerCase() === 'self'
          ? ''
          : '',
    },
    gstDtlSubHeading: `Regd Office: ${item?.billingAddress ?? 'N/A'},`,
    gstState: item?.state ?? 'N/A',
    gstPinCode: item?.pinCode ?? 'N/A',
    gstDtlSubHeadingTwo: `GSTIN: ${item?.gstNumber ?? 'N/A'}`,
    gstDtlCardIcOne: 'sprite icEditHollow',
    gstDtlCardIcTwo: 'sprite icBin',
    rowDeleteData: {
      gstOwner: item?.gstOwner ?? 'N/A',
      companyName: item?.companyName ?? 'N/A',
      gstNumber: item?.gstNumber ?? 'N/A',
      billingAddress: item?.billingAddress ?? 'N/A',
      travellerGstId: item?.travellerGstId ?? null,
    },
    rowEditData: {
      gstOwner: item?.gstOwner?.charAt(0)?.toUpperCase() + item?.gstOwner.slice(1) ?? 'N/A',
      gstNumber: item?.gstNumber ?? 'N/A',
      billingAddress: item?.billingAddress ?? 'N/A',
      companyName: item?.companyName ?? 'N/A',
      state: item?.state ?? 'N/A',
      pinCode: item?.pinCode ?? 'N/A',
      isDefault: item?.isDefault ?? false,
      travellerGstId: item?.travellerGstId ?? null,
    },
  }));
}
